@if (shouldShow()) {
  <div class="subtitle-container">
    <div class="subtitle-text" [innerHTML]="displayedText() | markdown">
    </div>
  </div>
}

<!-- Video Link Display -->
@if (showVideoLink() && primaryVideoResult()) {
  <div class="video-link-container"
       [class.center-position]="!isVisible()"
       [class.bottom-position]="isVisible()">
    <button class="video-link-button" (click)="onVideoLinkClick()">
      {{ primaryVideoResult()?.title }}
    </button>
  </div>
}
